
/*
 ## External Dependencies ##
 - agendor-web/public_html/src/javascript/obj/Produto.js -> to use function Filtros
 - jQuery ($)

 In the future, when we stop having js files in 2 projects, this comment should be
 removed and the dependency should be declared with require()
 */

var Reflux = require("reflux");
var ListingActions = require("app/shared/actions/listing-actions");
var ListingStore = require("app/shared/stores/listing-store");
var ListingSort = require("./listing-sort");
var agendorAPI = require("app/util/api/agendor-api");
var moment = require("moment");
var cx = require("classnames");
var _ = require("underscore");
var Dropdown = require("app/shared/components/Dropdown/dropdown");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var ListingFilterDropdownProducts = require("./listing-filter-dropdown-products");
var EntitySuggestions = require("app/shared/components/EntitySuggestions/entity-suggestions");

var ListingFilterBox = React.createClass({
  mixins: [Reflux.ListenerMixin],
  getInitialState: function(){
    var initialState = ListingStore.getDefaultData(this.props.filters);
    initialState.qpp = this.props.qpp;
    initialState.pg = this.props.pg;
    return initialState;
  },
  componentDidMount: function() {
    ListingActions.handleFilterOverrides(this.props.filters);

    agendorAPI.sessionId = this.props.token;
    this.listenTo(ListingStore, this.setState);
    $(document).trigger("ListingFilter.ready");
  },
  render: function(){
    var filters = this.state.filters[this.state.env];
    var DEAL_STATUS_LOST = 3;
    var isStatusLostSelected = this.state.filterValues.sn.value == DEAL_STATUS_LOST;
    var lossReasonFilterClasses = cx("listingFilter-transitionWidth d-ib", {
      "w-165": isStatusLostSelected,
      "mr-0": !isStatusLostSelected
    });

    var isMoreFiltersOpened = this.state.filterValues.moreFilters.opened && !this.state.subEnv;
    var isCurrentEnvDeal = this.state.env === "deal";

    var moreFiltersRowClasses = cx("listingFilter-moreFiltersTransition", {
      "o-100 mb-15": isMoreFiltersOpened,
      "h-75": isMoreFiltersOpened && isCurrentEnvDeal,
      "h-30": isMoreFiltersOpened && !isCurrentEnvDeal
    });

    return (
      <div className="bootstrap-agendor">
        <div className="listingFilter">
          <form name="formBuscarGeral" id="formBuscarGeral" role="form" className="listingFilter-form form-inline">
            <input type="hidden" ref="formIdUsuarioLogin" id="formIdUsuarioLogin" value={this.props.formIdUsuarioLogin} />
            {/*Qualtidade por página*/}
            <input type="hidden" ref="qpp" id="qpp" value={this.state.qpp} />
            {/*Página*/}
            <input type="hidden" ref="pg" id="pg" value={this.state.pg} />
            <input type="hidden" ref="q" name="q" id="q" value={this.state.filterValues.q.value} />
            {/*Categoria*/}
            <input type="hidden" ref="ct" name="ct" id="ct" value={this.state.filterValues.ct.value} />
            {/*Cargo*/}
            <input type="hidden" ref="ca" name="ca" id="ca" value={this.state.filterValues.ca.value} />
            {/*Setor*/}
            <input type="hidden" ref="st" name="st" id="st" value={this.state.filterValues.st.value} />
            {/*Status do Negócio*/}
            <input type="hidden" ref="sn" name="sn" id="sn" value={this.state.filterValues.sn.value} />
            {/*Motivo de Perda*/}
            <input type="hidden" ref="mp" name="mp" id="mp" value={this.state.filterValues.mp.value} />
            {/*Estado*/}
            <input type="hidden" ref="e" name="e" id="e" value={this.state.filterValues.e.value} />
            {/*Empresa*/}
            <input type="hidden" ref="em" name="em" id="em" value={this.state.filterValues.em.value} />
            {/*Pessoa*/}
            <input type="hidden" ref="p" name="p" id="p" value={this.state.filterValues.p.value} />
            {/*Cidade*/}
            <input type="hidden" ref="c" name="c" id="c" value={this.state.filterValues.c.value} />
            {/*Bairro*/}
            <input type="hidden" ref="b" name="b" id="b" value={this.state.filterValues.b.value} />
            {/*Usuário Responsavel*/}
            <input type="hidden" ref="ur" name="ur" id="ur" value={this.state.filterValues.ur.value} />
            {/*Data de conclusão inicial*/}
            <input type="hidden" ref="dci" name="dci" id="dci" value={this.state.filterValues.dci.value} />
            {/*Data de conclusão final*/}
            <input type="hidden" ref="dcf" name="dcf" id="dcf" value={this.state.filterValues.dcf.value} />
            {/*Data de início inicial*/}
            <input type="hidden" ref="dii" name="dii" id="dii" value={this.state.filterValues.dii.value} />
            {/*Data de início final*/}
            <input type="hidden" ref="dif" name="dif" id="dif" value={this.state.filterValues.dif.value} />
            {/*Etapa*/}
            <input type="hidden" ref="et" name="et" id="et" value={this.state.filterValues.et.value} />
            {/*CNPJ*/}
            <input type="hidden" ref="cnpj" name="cnpj" id="cnpj" value={this.state.filterValues.cnpj.value} />
            {/*Produtos*/}
            <input type="hidden" ref="pro" name="pro" id="pro" value={this.state.filterValues.pro.value} />
            {/*Oridem Lead*/}
            <input type="hidden" ref="origemLead" name="origemLead" id="origemLead" value={this.state.filterValues.origemLead.value} />
            {/*Esquecidos*/}
            <input type="hidden" ref="forgotten" name="forgotten" id="forgotten" value={this.state.filterValues.forgotten.value} />
            {/*Equipes*/}
            <input type="hidden" ref="team" name="team" id="team" value={this.state.filterValues.team.value} />
            {/*Congelados*/}
            <input type="hidden" ref="frozen" name="frozen" id="frozen" value={this.state.filterValues.frozen.value} />
            {/*Funil*/}
            <input type="hidden" ref="funil" name="funil" id="funil" value={this.state.filterValues.funil.value} />
            {/*Usuário*/}
            <input type="hidden" ref="u" name="u" id="u" value={this.state.filterValues.u.value} />
            {/*Funil inicial*/}
            <input type="hidden" ref="fi" name="fi" id="fi" value={this.state.filterValues.fi.value} />

            {(this.state.subEnv=="pipeline")?
            <input type="hidden" ref="orderBy" name="orderBy" id="orderBy" value={this.state.orderBy.value} />
            :null}

            <div className="listingFilter-options">
              <span className="c-999 fw-bold mr-5 tt-upper">Filtros</span>
              <div className="listingFilter-selects d-f mt-10" >
                {
                  (filters.indexOf("ct") != -1)
                    ? <div className="minw-110 maxw-130">
                        <ListingFilterSelect
                          {...this.state.selects.ct}
                          selectedOption={this.state.filterValues.ct.value}
                          highlight={this.state.filterValues.ct.highlight}
                          id="filter-select-category"
                          filterLabel="categoria"/>
                      </div>
                    : null
                }
                {
                  (filters.indexOf("sn") != -1 && this.state.subEnv == null)
                    ? <div>
                        <ListingFilterSelect
                          {...this.state.selects.sn}
                          selectedOption={this.state.filterValues.sn.value}
                          highlight={this.state.filterValues.sn.highlight}
                          id="filter-select-status"
                          filterLabel="status"
                          className={cx("minw-100",
                            isStatusLostSelected
                              ? "maxw-100 u-r-radius-0"
                              : "maxw-150"
                          )}/>
                      </div>
                    : null
                }
                {
                  (filters.indexOf("mp") != -1 && this.state.subEnv == null)
                    ? <div className={lossReasonFilterClasses} >
                        <ListingFilterSelect
                            {...this.state.selects.mp}
                            selectedOption={this.state.filterValues.mp.value}
                            highlight={this.state.filterValues.mp.highlight}
                            id="filter-select-lossReason"
                            filterLabel="motivo de perda"
                            visible={isStatusLostSelected}
                            className="u-l-radius-0 bl-n" />
                      </div>
                    : null
                }
                {
                  (filters.indexOf("et") != -1 && !isStatusLostSelected)
                    ? <div className="minw-85 maxw-100">
                        <DealStageSelect
                          {...this.state.selects.et}
                          selectedOption={this.state.filterValues.et.value}
                          highlight={this.state.filterValues.et.highlight}
                          id="filter-select-stage"
                          filterLabel="etapa"
                          subEnv={this.state.subEnv} />
                      </div>
                    : null
                }
                {
                  (filters.indexOf("ur") != -1)
                    ? <UserOwnerSelect
                      {...this.state.selects.ur}
                      selectedOption={this.state.filterValues.ur.value}
                      highlight={this.state.filterValues.ur.highlight}
                      id="filter-select-user-owner"
                      filterLabel="usuário responsável"/>
                    : null
                }
                {
                  (filters.indexOf("e") != -1)
                    ? <div className="minw-90 maxw-130">
                        <ListingFilterSelect
                          {...this.state.selects.e}
                          selectedOption={this.state.filterValues.e.value}
                          highlight={this.state.filterValues.e.highlight}
                          id="filter-select-state"
                          filterLabel="estado"/>
                      </div>
                    : null
                }
                {
                  (filters.indexOf("c") != -1)
                    ? <ListingFilterDropdownInput
                      value={this.state.filterValues.c.value || ""}
                      label="Cidade"
                      name="c"
                      highlight={this.state.filterValues.c.highlight}
                      placeholder="Digite o nome da cidade"
                      filterLabel="cidade"
                      className="maxw-90"/>
                    : null
                }
                {
                  (filters.indexOf("b") != -1)
                    ? <ListingFilterDropdownInput
                      value={this.state.filterValues.b.value || ""}
                      label="Bairro"
                      name="b"
                      highlight={this.state.filterValues.b.highlight}
                      placeholder="Digite o nome do bairro"
                      filterLabel="bairro"
                      className="maxw-85" />
                    : null
                }
                {
                  (filters.indexOf("pro") != -1)
                    ? <ListingFilterDropdownProducts
                      data={ _.pick(this.state.filterValues, (_value, key) => key.startsWith("pro")) }
                      label="Produtos"
                      name="pro"
                      className="maxw-110" />
                    : null
                }
                {
                  (filters.indexOf("forgotten") != -1)
                    ? <ForgottenSelect
                      {...this.state.selects.forgotten}
                      selectedOption={this.state.filterValues.forgotten.value}
                      highlight={this.state.filterValues.forgotten.highlight}
                      id="filter-select-forgotten"
                      filterLabel="esquecidos"/>
                    : null
                }
                <MoreFiltersSettings {...this.state} filters={filters}
                  moreFiltersClick={ListingActions.handleMoreFiltersClick} />
              </div>
              {
                !this.state.subEnv ?
                <div className={moreFiltersRowClasses}>
                  <MoreFilters visible={this.state.filterValues.moreFilters.opened} filterValues={this.state.filterValues}
                    filters={filters}
                    selects={this.state.selects}
                    env={this.state.env}
                    subEnv={this.state.subEnv} />
                </div> : null
              }

              <ListingFilterValues filterValues={this.state.filterValues} />
            </div>
            <ListingFilterExtra
              values={this.state.filterValues}
              totalResults={this.state.totalResults}
              orderBy={this.state.orderBy}
              env={this.state.env}
              subEnv={this.state.subEnv} />
          </form>
        </div>
      </div>
    );
  }
});

const MoreFiltersSettings = (props) => {
  if (props.filters.indexOf("moreFilters") != -1) {
    if (!props.subEnv) {
      return <MoreFiltersButton handleClick={props.moreFiltersClick}
        filterState={props.filterValues.moreFilters} />;
    } else {
      return <MoreFilters filterValues={props.filterValues}
          filters={props.filters}
          selects={props.selects}
          visible={true}
          env={props.env}
          subEnv={props.subEnv} />;
    }
  } else {
    return <noscript />;
  }
}

const MoreFiltersButton = (props) => {
  var isButtonHighlighted = props.filterState.opened || props.filterState.highlighted;
  var moreFiltersButtonClasses = cx("fw-400 fs-12",{
    "listingFilter-moreFiltersButton c-lightSlateGray": !isButtonHighlighted,
    "listingFilter-moreFiltersButton listingFilter-moreFiltersButton--active c-white": isButtonHighlighted,
  });
  var chevron = cx("fs-16 custom-glyphicon", {
    "icon-chevron-down": !props.filterState.opened,
    "icon-chevron-up": props.filterState.opened
  });

  return (
    <div className="ml-10">
      <button type="button" className={moreFiltersButtonClasses} onClick={props.handleClick}>
        <span className={chevron}></span>
      </button>
    </div>
  );
};

const MoreFilters = (props) => {
  var DEAL_STATUS_LOST = 3;
  var isStatusLostSelected = props.filterValues.sn.value == DEAL_STATUS_LOST;
  var isPageDealList = props.env === "deal" && props.subEnv == null;
  var moreFilterClasses = cx('listingFilter-selects',
    'd-f',
    {'flex-wrap': isPageDealList},
    {'d-n': !props.visible}
  );
  return <div className={moreFilterClasses}>
  {
    (props.filters.indexOf("st") != -1)
      ? <div className="minw-90 maxw-90">
          <ListingFilterSelect
            {...props.selects.st}
            selectedOption={props.filterValues.st.value}
            highlight={props.filterValues.st.highlight}
            id="filter-select-sector"
            filterLabel="setor"/>
        </div>
      : null
  }
  {
    (props.filters.indexOf("et") != -1 && isStatusLostSelected)
      ? <div className="minw-85 maxw-100">
          <ListingFilterSelect
            {...props.selects.et}
            selectedOption={props.filterValues.et.value}
            highlight={props.filterValues.et.highlight}
            id="filter-select-stage"
            filterLabel="etapa"/>
        </div>
      : null
  }
  {
    (props.filters.indexOf("funil") != -1 && props.subEnv == null)
      ? <div className="minw-85 maxw-100">
          <FunnelSelect
            {...props.selects.funil}
            selectedOption={props.filterValues.funil.value}
            highlight={props.filterValues.funil.highlight}
            id="filter-select-funil"
            filterLabel="funil"/>
        </div>
      : null
  }
  {
    (props.filters.indexOf("dc") != -1)
      ? <ListingFilterDropdownDatepicker
        value={props.filterValues.dc.value || ""}
        label="Data de conclusão"
        highlight={props.filterValues.dc.highlight}
        name="dc"
        filterLabel="data de conclusão"
        finalDateAlias = "dcf"
        filterLabelTitle = "CONCLUSÃO"
        initialDateAlias = "dci" />
      : null
  }
  {
    (props.filters.indexOf("di") != -1)
    ? <ListingFilterDropdownDatepicker
      value={props.filterValues.di.value || ""}
      label="Data de início"
      highlight={props.filterValues.di.highlight}
      name="di"
      filterLabel="data de início"
      finalDateAlias = "dif"
      filterLabelTitle = "INÍCIO"
      initialDateAlias = "dii"
      className="minw-140"/>
    : null
  }
  {
    (props.filters.indexOf("em") != -1)
      ? <ListingFilterDropdownSuggestion
        value={props.filterValues.em.value || ""}
        label="Empresa"
        name="em"
        placeholder="Digite o nome da empresa"
        highlight={props.filterValues.em.highlight}
        id="inputFiltroEmpresa"
        filterLabel="empresa"/>
      : null
  }
  {
    (props.filters.indexOf("p") != -1)
      ? <ListingFilterDropdownSuggestion
        value={props.filterValues.p.value || ""}
        label="Pessoa"
        name="p"
        placeholder="Digite o nome da pessoa"
        highlight={props.filterValues.p.highlight}
        id="inputFiltroPessoa"
        filterLabel="pessoa"/>
      : null
  }
  {
    (props.filters.indexOf("cnpj") != -1)
    ? <ListingFilterDropdownInput
      value={props.filterValues.cnpj.value || ""}
      label="CNPJ"
      name="cnpj"
      highlight={props.filterValues.cnpj.highlight}
      placeholder="Digite o CNPJ"
      filterLabel="CNPJ"
      className="maxw-100"/>
    : null
  }
  {
    (props.filters.indexOf("ca") != -1)
    ? <ListingFilterDropdownInput
      value={props.filterValues.ca.value || ""}
      label="Cargo"
      name="ca"
      highlight={props.filterValues.ca.highlight}
      placeholder="Digite o cargo"
      filterLabel="cargo"
      className="maxw-100"/>
    : null
  }
  {
    (props.filters.indexOf("origemLead") != -1)
      ? <LeadOriginSelect
        {...props.selects.origemLead}
        selectedOption={props.filterValues.origemLead.value}
        highlight={props.filterValues.origemLead.highlight}
        id="filter-select-origem-lead"
        filterLabel="origem"/>
      : null
  }
  {
    (props.filters.indexOf("team") != -1)
      ? <TeamSelect
        {...props.selects.team}
        selectedOption={props.filterValues.team.value}
        highlight={props.filterValues.team.highlight}
        id="filter-select-team"
        filterLabel="equipes"/>
      : null
  }
  </div>
}

var ListingFilterSelect = React.createClass({
  getDefaultProps: function() {
    return { visible: true };
  },
  applyFilter: function(obj, e, updateListing){
    var filter = {
      name: this.props.name,
      value: obj.value,
      label: obj.text,
      filterLabel: this.props.filterLabel
    };
    ListingActions.applyFilter(filter, updateListing);
  },
  componentDidMount: function(){
    ListingActions.loadSelectOptions(this.props);
  },
  willUpdateLabelText: function(prevProps, currentProps) {
    var optionsLoaded = prevProps.options.length != currentProps.options.length;

    return currentProps.selectedOption && (optionsLoaded);
  },
  getSelectedText: function(){
    var selectedOption = _.find(this.props.options, function(option) {
      return option.id.toString().toLowerCase() == this.props.selectedOption.toString().toLowerCase();
    }.bind(this));
    return selectedOption.name;
  },
  render: function(){
    return (
      (this.props.visible)
      ? <Dropdown
          options={this.props.options}
          value={this.props.selectedOption}
          handleCustomChange={this.applyFilter}
          className={this.props.className} />
      : null
    );
  }
});

var FunnelSelect = React.createClass({
  applyFilter: function(obj, e){
    var filter = {
      name: this.props.name,
      value: obj.value,
      label: obj.text,
      filterLabel: this.props.filterLabel
    };
    ListingActions.applyFilter(filter);
  },
  componentDidMount: function(){
    ListingActions.loadFunnelOptions(this.props);
  },
  componentDidUpdate: function(prevProps) {
    if (this.props.selectedOption && prevProps.options.length != this.props.options.length) {
      var selectedText = this.getSelectedText();
      var selectedValues = {
        value: this.props.selectedOption,
        text: selectedText
      }
      this.applyFilter(selectedValues, null);
    }
  },
  getSelectedText: function(){
    var selectedOption = _.find(this.props.options, function(option) {
      return option.id == this.props.selectedOption;
    }.bind(this));
    return selectedOption.name;
  },
  render: function(){
    return (
      <Dropdown
        options={this.props.options}
        value={this.props.selectedOption}
        handleCustomChange={this.applyFilter}
      />
    );
  }
});

var DealStageSelect = React.createClass({
  applyFilter: function(obj, e, updateListing){
    var filter = {
      name: this.props.name,
      value: obj.value,
      label: obj.text,
      filterLabel: this.props.filterLabel
    };
    ListingActions.applyFilter(filter, updateListing);
  },
  componentDidMount: function(){
    ListingActions.loadDealStageOptions(this.props);
  },
  willUpdateLabelText: function(prevProps, currentProps) {
    var optionsLoaded = prevProps.options.length != currentProps.options.length;

    return currentProps.selectedOption && (optionsLoaded);
  },
  getSelectedText: function(){
    var selectedOption = _.find(this.props.options, function(option) {
      return option.id.toString().toLowerCase() == this.props.selectedOption.toString().toLowerCase();
    }.bind(this));
    return selectedOption.name;
  },
  render: function(){
    let groupingDealStage = null;

    if (this.props.options.length > 1 && this.props.subEnv == null) {
      groupingDealStage = this.props.groups;
    }

    return (
      <Dropdown
        options={this.props.options}
        value={this.props.selectedOption}
        handleCustomChange={this.applyFilter}
        groups={groupingDealStage}
      />
    );
  }
});

var UserOwnerSelect = React.createClass({
  applyFilter: function(obj, e){
    var filter = {
      name: this.props.name,
      value: obj.value,
      label: obj.text,
      filterLabel: this.props.filterLabel
    };
    ListingActions.applyFilter(filter);
  },
  componentDidMount: function(){
    ListingActions.loadUserOwnerOptions(this.props);
  },
  componentDidUpdate: function(prevProps) {
    if (this.props.selectedOption && prevProps.options.length != this.props.options.length) {
      var selectedText = this.getSelectedText();
      var selectedValues = {
        value: this.props.selectedOption,
        text: selectedText
      }
      this.applyFilter(selectedValues, null, false);
    }
  },
  getSelectedText: function(){
    var selectedOption = _.find(this.props.options, function(option) {
      return option.id == this.props.selectedOption;
    }.bind(this));
    return selectedOption.name;
  },
  render: function(){
    var groupingUserOwner;
    if(this.props.options.length > 1) {
      let activeLabel = (window && window.loggedUserIsAdmin == "1") ? "Ativos" : "Usuários";
      groupingUserOwner = [
        { id: "nogroup", name: "" },
        { id: "active", name: activeLabel },
        { id: "inactive", name: "Inativos" }
      ];
    }
    return (
      <div className="minw-130 maxw-150">
        <Dropdown options={this.props.options} value={this.props.selectedOption} handleCustomChange={this.applyFilter} groups={groupingUserOwner} />
      </div>
    );
  }
});

var LeadOriginSelect = React.createClass({
  applyFilter: function(obj, e){
    var filter = {
      name: this.props.name,
      value: obj.value,
      label: obj.text,
      filterLabel: this.props.filterLabel
    };
    if (obj.value == "") {
      ListingActions.removeFilter(filter);
    } else {
      ListingActions.applyFilter(filter);
    }
  },
  componentDidMount: function(){
    ListingActions.loadLeadOriginOptions(this.props);
  },
  componentDidUpdate: function(prevProps) {
    if (this.props.selectedOption && prevProps.options.length != this.props.options.length) {
      var selectedText = this.getSelectedText();
      var selectedValues = {
        value: this.props.selectedOption,
        text: selectedText
      }
      this.applyFilter(selectedValues, null, false);
    }
  },
  getSelectedText: function(){
    var selectedOption = _.find(this.props.options, function(option) {
      return option.id == this.props.selectedOption;
    }.bind(this));
    return selectedOption.name;
  },
  render: function(){
    return (
      <div className="minw-100 maxw-120 dropdown">
        <Dropdown options={this.props.options} value={this.props.selectedOption} handleCustomChange={this.applyFilter} />
      </div>
    );
  }
});

var ForgottenSelect = React.createClass({
  applyFilter: function(obj, e){
    var filter = {
      name: this.props.name,
      value: obj.value,
      label: obj.text,
      filterLabel: this.props.filterLabel
    };
    if (obj.value == "") {
      ListingActions.removeFilter(filter);
    } else {
      ListingActions.applyFilter(filter);
    }
  },
  componentDidUpdate: function(prevProps) {
    if (this.props.selectedOption && prevProps.options.length != this.props.options.length) {
      var selectedText = this.getSelectedText();
      var selectedValues = {
        value: this.props.selectedOption,
        text: selectedText
      }
      this.applyFilter(selectedValues, null, false);
    }
  },
  getSelectedText: function(){
    var selectedOption = _.find(this.props.options, function(option) {
      return option.id == this.props.selectedOption;
    }.bind(this));
    return selectedOption.name;
  },
  render: function(){
    return (
      <div className="minw-120 maxw-140 dropdown">
        <Dropdown options={this.props.options} value={this.props.selectedOption} handleCustomChange={this.applyFilter} />
      </div>
    );
  }
});

var TeamSelect = React.createClass({
  applyFilter: function(obj, e){
    var filter = {
      name: this.props.name,
      value: obj.value,
      label: obj.text,
      filterLabel: this.props.filterLabel
    };
    if (obj.value == "") {
      ListingActions.removeFilter(filter);
    } else {
      ListingActions.applyFilter(filter);
    }
  },
  componentDidMount: function(){
    ListingActions.loadSelectOptions(this.props);
  },
  componentDidUpdate: function(prevProps) {
    if (this.props.selectedOption && prevProps.options.length != this.props.options.length) {
      var selectedText = this.getSelectedText();
      var selectedValues = {
        value: this.props.selectedOption,
        text: selectedText
      }
      this.applyFilter(selectedValues, null, false);
    }
  },
  getSelectedText: function(){
    var selectedOption = _.find(this.props.options, function(option) {
      return option.id == this.props.selectedOption;
    }.bind(this));
    return selectedOption.name;
  },
  render: function(){
    return (
      <div className="minw-100 maxw-120 dropdown">
        <Dropdown options={this.props.options} value={this.props.selectedOption} handleCustomChange={this.applyFilter} />
      </div>
    );
  }
});

var ListingFilterDropdownDatepicker = React.createClass({
  propTypes: {
    finalDateAlias: React.PropTypes.string,
    filterLabelTitle: React.PropTypes.string,
    initialDateAlias: React.PropTypes.string
  },
  getDefaultProps: function() {
    return {
      finalDateAlias: "",
      filterLabelTitle: "",
      initialDateAlias: "",
      className: ""
    };
  },
  getInitialState: function(){
    return {selectedDatesQty:0};
  },
  componentDidMount: function(){
    var self = this;
    var dropdown = this.refs.dropdown;
    var dropdownMenu = this.refs["dropdown-menu"];

    var componentRef = this.refs[this.props.name];
    var initialDateRef = $(this.refs[this.props.initialDateAlias]);
    var finalDateRef = $(this.refs[this.props.finalDateAlias]);

    var initialDate = (!isEmpty($("#" + this.props.initialDateAlias).val()))?$("#" + this.props.initialDateAlias).val():null;
    var finalDate = (!isEmpty($("#" + this.props.finalDateAlias).val()))?$("#" + this.props.finalDateAlias).val():null;

    var filterLabel = this.props.filterLabel;
    var filterLabelTitle = this.props.filterLabelTitle;
    var initialDateString = this.props.initialDateAlias;
    var finalDateString = this.props.finalDateAlias;

      initialDateRef.datepicker({
        dateFormat:"yy-mm-dd",
        defaultDate:initialDate,
        maxDate:finalDate,
        onSelect: function( selectedDate ) {
          self.selectDate();
          finalDateRef.datepicker( "option", "minDate", selectedDate );
          ListingActions.applyFilter({
            name: initialDateString,
            value: selectedDate,
            label: filterLabelTitle + " De: " + moment(selectedDate).format("DD/MM/YYYY"),
            filterLabel: filterLabel
          });
        }
      });


      finalDateRef.datepicker({
        dateFormat:"yy-mm-dd",
        defaultDate:finalDate,
        minDate:initialDate,
        onSelect: function( selectedDate ) {
          self.selectDate();
          initialDateRef.datepicker( "option", "maxDate", selectedDate );
          ListingActions.applyFilter({
            name: finalDateString,
            value: selectedDate,
            label: filterLabelTitle + " Até: " + moment(selectedDate).format("DD/MM/YYYY"),
            filterLabel: filterLabel
          });
        }
      });


    $(dropdown).on("hide.bs.dropdown", function () {
      return (!$(dropdownMenu).is(":hover"));
    }.bind(this));
  },
  componentDidUpdate: function(prevProps) {
    if (this.shouldUpdate(prevProps, this.props)) {
      var initialDate = (!isEmpty($("#" + this.props.initialDateAlias).val()))?$("#" + this.props.initialDateAlias).val():null;
      var finalDate = (!isEmpty($("#" + this.props.finalDateAlias).val()))?$("#" + this.props.finalDateAlias).val():null;

      if (!!initialDate) {
        ListingActions.applyFilter({
          name: this.props.initialDateAlias,
          value: initialDate,
          label: this.props.filterLabelTitle + " De: " + moment(initialDate).format("DD/MM/YYYY"),
          filterLabel: this.props.filterLabel
        });
      }

      if (!!finalDate) {
        ListingActions.applyFilter({
          name: this.props.finalDateAlias,
          value: finalDate,
          label: this.props.filterLabelTitle + " Até: " + moment(finalDate).format("DD/MM/YYYY"),
          filterLabel: this.props.filterLabel
        });
      }
    }
  },
  shouldUpdate: function(prevProps, props) {
    return props.initialDateAlias != prevProps.initialDateAlias ||
      props.finalDateAlias != prevProps.finalDateAlias;
  },
  selectDate: function(){
    var state = this.state;
    this.setState({selectedDatesQty:state.selectedDatesQty+1});
  },
  render: function(){
    var buttonClasses = cx("pr-20", "dropdown-toggle", {
      "highlighted": this.props.highlight
    });
    var dropdownClasses = cx(this.props.className, "maxw-170", "dropdown", {
      "open": (this.state.selectedDatesQty>0&&!(this.state.selectedDatesQty%2==0))
    });

    return (
      <div ref="dropdown" className={dropdownClasses}>
        <button className={buttonClasses} type="button" data-toggle="dropdown">
          <div className="ovf-h">
            {this.props.label}
          </div>
          <span className="caret p-a custom-glyphicon icon-chevron-down"></span>
        </button>
        <div className="dropdown-menu" role="menu" ref="dropdown-menu">
          <div ref={this.props.name} className="w-450">
            <div ref={this.props.initialDateAlias} className="mr-10 f-l"></div>
            <div ref={this.props.finalDateAlias} className="f-l"></div>
            <div className="clear"></div>
          </div>
        </div>
      </div>
    );
  }
});

var ListingFilterDropdownInput = React.createClass({
  mixins: [React.addons.LinkedStateMixin],
  getInitialState: function(){
    return {value:this.props.value};
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({value:nextProps.value});
  },
  componentDidMount: function(){
    var dropdown = this.refs.dropdown;
    var dropdownMenu = this.refs["dropdown-menu"];
    var input = this.refs.input;

    $(dropdown).on("shown.bs.dropdown", function () {
      input.focus();
    }.bind(this));

    $(dropdown).on("hide.bs.dropdown", function () {
      if (this.props.value!=input.value){
        this.applyFilter(input);
      }
      return (!$(dropdownMenu).is(":hover"));
    }.bind(this));

    this.applyFilter(input, false);
  },
  onInputKeyDown: function(e){
    var dropdown = this.refs.dropdown;
    var input = e.target;
    if(e.keyCode==13||e.keyCode==9){
      e.preventDefault();
      input.blur();
      $(dropdown).removeClass("open");

      if (this.props.value!=input.value){
        this.applyFilter(input);
      }
    } else if(e.keyCode==27) {
      input.blur();
      $(dropdown).removeClass("open");
    }
  },
  applyFilter: function(input, updateListing){
    var filter = {
      name: input.name,
      value: input.value,
      label: input.value,
      filterLabel: this.props.filterLabel
    };

    ListingActions.applyFilter(filter, updateListing);
  },
  render: function(){
    var buttonClasses = cx("pr-20", {
      "dropdown-toggle": true,
      "highlighted": this.props.highlight
    });
    return (
    <div className={cx("dropdown", this.props.className)} ref="dropdown">
      <button className={buttonClasses} type="button" data-toggle="dropdown">
        <div className="ovf-h">
          {this.props.label}
        </div>
        <span className="caret p-a custom-glyphicon icon-chevron-down"></span>
      </button>
      <div className="dropdown-menu" role="menu" ref="dropdown-menu">
        <input ref="input" type="text" valueLink={this.linkState("value")} onKeyDown={this.onInputKeyDown} name={this.props.name} className="form-control input-sm" placeholder={this.props.placeholder} />
      </div>
    </div>
    );
  }
});

var ListingFilterDropdownSuggestion = React.createClass({
  componentDidMount: function(){
    $(this.refs.dropdown).on("shown.bs.dropdown", function () {
      this.refs.suggestions.focusInput();
    }.bind(this));

    if (this.props.value != "") {
      ListingActions.applyFilter({
        name: this.props.name,
        value: this.props.value,
        label: this.props.filterLabel || this.props.value,
        filterLabel: this.props.filterLabel
      }, false);
    }
  },
  onSuggestionSelect: function(entity) {
    this.refs.suggestions.hideSuggestions();

    ListingActions.applyFilter({
      name: this.props.name,
      value: entity.id,
      label: entity.nome,
      filterLabel: this.props.filterLabel
    });
  },
  allowedTypes: function() {
    if (this.props.name === "em") {
      return ["organization"];
    } else {
      return ["person"];
    }
  },
  render: function(){
    var buttonClasses = cx("pr-20", {
      "dropdown-toggle": true,
      "highlighted": this.props.highlight
    });
    return (
    <div className="dropdown maxw-115" ref="dropdown">
      <button className={buttonClasses} type="button" data-toggle="dropdown">
        <div className="ovf-h">
          {this.props.label}
        </div>
        <span className="caret p-a custom-glyphicon icon-chevron-down"></span>
      </button>
      <div className="dropdown-menu w-230" role="menu" ref="dropdown-menu">
        <EntitySuggestions
          instanceKey={`listingFilter-${this.props.name}`}
          placeholder={this.props.placeholder}
          allowCreate={false}
          allowedTypes={this.allowedTypes()}
          onSelect={this.onSuggestionSelect}
          ref="suggestions"
        />
      </div>
    </div>
    );
  }
});

var ListingFilterValue = React.createClass({
  removeFilter: function(e){
    this.onMouseOut();
    if(this.props.cbfOnClick) {
      this.props.cbfOnClick();
    }
    ListingActions.removeFilter(this.props);
  },
  getRealFilterName: function(){
    var name = this.props.name;
    if(this.props.name.substr(0,3)=="pro") {
      name = "pro";
    }
    else if(this.props.name=="dci"||this.props.name=="dcf") {
      name = "dc";
    }
    else if(this.props.name=="dii"||this.props.name=="dif") {
      name = "di";
    }
    return name;
  },
  onMouseOver: function(e){
    ListingActions.highlightFilter(this.getRealFilterName());
  },
  onMouseOut: function(e){
    ListingActions.diminishFilters();
  },
  render: function() {
    var filterValue = (
      (this.props.value&&!this.props.hide)
        ? <span
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            key={this.props.key}
            className="listingFilter-selectedOption">
          {this.props.label}
          <a href="javascript:void(0);" onClick={this.removeFilter}>
            <span className="custom-glyphicon icon-close fs-12"></span>
          </a>
          </span>
        : null
    );
    return filterValue;
  }
});

var ListingFilterDealStatusWithLossReasonValue = React.createClass({
  getConcatenatedLabel: function() {
    var isLossReasonSelected = (this.props.fullFilters.mp.value != "");
    var separatorText;
    var lossReasonLabel;

    if(isLossReasonSelected && this.props.value != -1) {
      separatorText = " por ";
      lossReasonLabel = this.props.label;
    } else {
      separatorText = " sem ";
      lossReasonLabel = this.props.filterLabel;
    }

    return (
      <span>
        <span>{this.props.fullFilters.sn.label}</span>
        <span className="tt-lower">{separatorText}</span>
        <span>{lossReasonLabel}</span>
      </span>
    );
  },
  render: function() {
    var isDealStatusFilter = this.props.name === "sn";
    var isDealStatusSelected = (
      this.props.fullFilters.sn.value != undefined &&
      this.props.fullFilters.sn.value != ""
    );
    var isLossReasonSelected = (
      this.props.fullFilters.mp.value != undefined &&
      this.props.fullFilters.mp.value != ""
    );

    if (isDealStatusFilter && isLossReasonSelected) {
      return null;
    } else {
      var props = _.clone(this.props);

      if (isDealStatusSelected && isLossReasonSelected) {
        props.label = this.getConcatenatedLabel();
      }

      return <ListingFilterValue {...props} />;
    }
  }
});

var ListingFilterValues = React.createClass({
  removeAllFilters: function(e){
    ListingActions.removeAllFilters();
  },
  render: function(){
    var filterValues = [];
    var isAnyFilterApplied = false;

    for (var key in this.props.filterValues) {
      if (this.props.filterValues.hasOwnProperty(key)) {
        var filterValue = this.props.filterValues[key];
        isAnyFilterApplied = (
          !isAnyFilterApplied
          && filterValue.value
          && !filterValue.hide
        ) ? true : isAnyFilterApplied;

        if (filterValue.name === "sn" || filterValue.name === "mp") {
          filterValues.push(
            <ListingFilterDealStatusWithLossReasonValue
              {...filterValue}
              fullFilters={this.props.filterValues}
              key={key} />
          );
        } else if (filterValue.name) {
          filterValues.push(<ListingFilterValue {...filterValue} key={key} />);
        }

      }
    }

    return isAnyFilterApplied ? (
    <div>
      <hr />
      <div className="listingFilter-selectedOptions">
        <div className="pull-left d-f">
          {filterValues}
        </div>
        <div className="pull-right">
          <a href="javascript:void(0);" onClick={this.removeAllFilters}>Remover filtros</a>
        </div>
        <div className="clear"></div>
      </div>
    </div>) : null;
  }
});

var ListingFilterExtra = React.createClass({
  mixins: [React.addons.LinkedStateMixin],
  getInitialState: function(){
    return ({
      q: this.props.values.q.value || "",
      frozen: this.props.values.frozen.value
    });
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      q: nextProps.values.q.value || "",
      frozen: nextProps.values.frozen.value
    });
  },
  onInputKeyDown: function(e){
    if(e.keyCode==13||e.keyCode==9){
      e.preventDefault();
      this.applyQuery();
    }
  },
  applyQuery: function(){
    var input = this.refs.input;
    var filter = {
      name: input.name,
      value: input.value,
      label: input.value,
      hide: true
    };
    if(this.props.values.q.value != input.value){
      ListingActions.applyFilter(filter);
    }
  },
  applyFrozen: function() {
    this.refs.frozenTooltip.hide();

    let newValue = this.state.frozen ? 0 : 1;
    ListingActions.applyFilter({
      name: "frozen",
      value: newValue,
      label: "Congelados",
      hide: true,
      preventRemoval: true
    });
  },
  clearFilter: function(e) {
    ListingActions.removeFilter({name:"q"});
  },
  render: function(){
    var queryInputPlaceholder, totalResultsLabel = null;
    switch(this.props.env){
      case "organization": queryInputPlaceholder = "Nome da empresa"; totalResultsLabel = "empresa(s)"; break;
      case "person": queryInputPlaceholder = "Nome da pessoa"; totalResultsLabel = "pessoa(s)"; break;
      case "deal": queryInputPlaceholder = "Buscar por nome ou título"; totalResultsLabel = "negócio(s)"; break;
      default: queryInputPlaceholder = "Nome da empresa"; totalResultsLabel = "empresa(s)"; break;
    }

    var clearFilterClasses = cx({
      "listingFilter-clearText": true,
      "hidden": !this.state.q
    });

    var frozenClass = cx("btn", "btn-filter", { "active": this.state.frozen });
    var frozenMessage = this.state.frozen
      ? "Os negócios congelados estão visíveis no funil. Clique para não exibir."
      : "Os negócios congelados estão ocultos no funil. Clique para exibir.";

    var orderByFlexClass = this.props.subEnv ? "flex-1" : "flex-auto";

    return (
    <div className="listingFilter-search d-f jc-sb">
      <div className="form-group flex-1">
        <div className="input-group w-300">
          <input valueLink={this.linkState("q")} onKeyDown={this.onInputKeyDown} ref="input" type="text" name="q" className="form-control c-fontGray" placeholder={queryInputPlaceholder} />
          <div className="input-group-btn ">
            <a className={clearFilterClasses} onClick={this.clearFilter} type="button"><span ref="glyphicon" className="glyphicon glyphicon-plus-sign"></span></a>
            <button className="btn btn-default" onClick={this.applyQuery} type="button"><span ref="glyphicon" className="custom-glyphicon icon-search"></span></button>
          </div>
        </div>
      </div>

      {(this.props.subEnv === "pipeline")?
      <div className="form-group flex-1 ta-c">
        <Tooltip title={frozenMessage} trigger="hover" ref="frozenTooltip">
          <button className={frozenClass} type="button" onClick={this.applyFrozen}>
            <span className="custom-glyphicon icon-freeze" />
            Exibir congelados
          </button>
        </Tooltip>
      </div>
      :null}

      {(this.props.subEnv!="salesMap")?
      <div className={"form-group ta-r " + orderByFlexClass}>
        <span className="mr-10"><span className="fw-bold mr-5">{this.props.totalResults}</span><span className="hidden-md hidden-sm hidden-xs">{totalResultsLabel}</span></span>
        <ListingSort orderBy={this.props.orderBy} env={this.props.env} />
      </div>
      :null}
    </div>
    );
  }
});

module.exports = ListingFilterBox;



// WEBPACK FOOTER //
// ./app/shared/components/List/listing-filter.jsx